export enum DepartmentType {
  Gabinete = "gabinete",
  Coordenacao = "coordenacao",
  Divisao = "divisao",
  Nucleo = "nucleo",
}

export interface Department {
  id: number
  name: string
  type: DepartmentType
  parentID?: number
}

export const departmentTypeLabels: Record<DepartmentType, string> = {
  [DepartmentType.Gabinete]: "Gabinete",
  [DepartmentType.Coordenacao]: "Coordenação",
  [DepartmentType.Divisao]: "Divisão",
  [DepartmentType.Nucleo]: "Núcleo",
}

// allowedParentTypes maps a department type to the type its parent must have.
// Gabinete has no parent (top of the hierarchy).
export const allowedParentTypes: Record<DepartmentType, DepartmentType | null> = {
  [DepartmentType.Gabinete]: null,
  [DepartmentType.Coordenacao]: DepartmentType.Gabinete,
  [DepartmentType.Divisao]: DepartmentType.Coordenacao,
  [DepartmentType.Nucleo]: DepartmentType.Coordenacao,
}
